"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerSelectionValidationSchema = void 0;
var _zod = require("zod");
var _types = require("../../../types");
const customerSelectionValidationSchema = exports.customerSelectionValidationSchema = _zod.z.object({
  customerType: _zod.z.nativeEnum(_types.ECustomerTypeSelection),
  existingCustomerId: _zod.z.number().nullish(),
  customerFirstName: _zod.z.string().optional(),
  customerSurname: _zod.z.string().optional()
}).superRefine((data, ctx) => {
  if (data.customerType === _types.ECustomerTypeSelection.ExistingCustomer) {
    if (data.existingCustomerId === undefined) {
      // Validate new customer selection
      if (!data.customerFirstName) {
        ctx.addIssue({
          code: _zod.z.ZodIssueCode.custom,
          message: 'First name is required.',
          path: ['customerFirstName']
        });
      }
      if (!data.customerSurname) {
        ctx.addIssue({
          code: _zod.z.ZodIssueCode.custom,
          message: 'Surname is required.',
          path: ['customerSurname']
        });
      }
      // Validate existing customer selection
    } else if (data.existingCustomerId === null) {
      ctx.addIssue({
        code: _zod.z.ZodIssueCode.custom,
        message: 'Customer selection is required.',
        path: ['existingCustomerId']
      });
    }
  }
});
